import UserDescription from "../core/UserDescription.tsx";
import UserTitle from "../core/UserTitle.tsx";
import UserImage from "../core/UserImage.tsx";
import { ReactNode } from "react";

const UserCompact = ({
  userId,
  children,
}: {
  userId: string;
  children?: ReactNode;
}) => {
  return (
    <div className="flex items-center p-3 shadow-xl w-full">
      <UserImage
        userId={userId}
        sizes="64px"
        className="w-32 h-32 aspect-square object-scale-down rounded-full"
      />

      <div className="card-body">
        <h1 className="card-title">
          <UserTitle userId={userId} />
        </h1>
        <div className="text-wrap">
          <UserDescription userId={userId} />
        </div>
        <div className="card-actions justify-end">{children}</div>
      </div>
    </div>
  );
};

export default UserCompact;
